export default {
  table_ordering: 'Bordbestilling',
  table: 'Bord',
  pickup_or_delivery: 'Afhentning eller levering',
  asap: 'Hurtigst muligt',
  served_in: 'Serveres om {{time}} min',
  not_taking_orders: 'Tager ikke imod bestillinger',
  not_your_table: 'Er det ikke dit bord? Scan koden på dit.',
  eating_here: {
    title: 'Spiser du her?',
    back_to_table: 'Bestil til {{table}}. Vi bringer den til dig.',
    scan_code: 'Scan QR-koden på dit bord for at bestille til det.',
  },
  notes: {
    table_unavailable: {
      title: 'Dette bords QR-kode virker ikke længere.',
      text: 'Spørg personalet. Du kan stadig bestille til afhentning.',
      text_no_pickup: 'Spørg personalet.',
    },
    table_ordering_off: {
      title: 'Bestilling ved bordet er ikke tilgængelig lige nu.',
      text: 'Du kan bestille til afhentning i stedet.',
    },
    load_failed: {
      title: 'Kunne ikke indlæse dit bord.',
      text: 'Scan QR-koden igen.',
    },
    closed: {
      title: 'Lukket lige nu.',
      text: 'Du kan bestille ved dit bord fra {{time}}.',
      text_later: 'Du kan bestille ved dit bord, når vi åbner igen.',
    },
    paused: {
      title: 'Tager ikke imod bestillinger lige nu.',
      text: 'Spørg personalet, eller prøv igen om et par minutter.',
    },
  },
  cart: {
    closed: 'Lukket lige nu. Du kan bestille ved dit bord fra {{time}}. Din kurv gemmes indtil da.',
    closed_later: 'Lukket lige nu. Din kurv gemmes, indtil vi åbner igen.',
    paused: 'Tager ikke imod bestillinger lige nu. Din kurv gemmes. Spørg personalet.',
  },
  cash_note: 'Betal kontant ved disken.',
  confirmation: {
    bring_to_table: 'Vi bringer din bestilling til dit bord.',
    your_table: 'Dit bord',
    moved_table: 'Flyttet til et andet bord? Oplys personalet om dit bestillingsnummer <strong>{{number}}</strong>.',
  },
  served: 'Serveret',
};
